<template>
  <div class="card">
    <div class="card-body p-0">
      <div class="row w-100 m-0">
        <div class="col-12 tenders-list padding-b-20 padding-t-20 padding-r-10 padding-l-10">
          <div class="d-flex flex-wrap gap-2">
            <tender-card @click="$router.push(`/timeless-tenders/tender/${tender.id}`)" :tender="tender" :selectedType="selectedType" :can-favorite="true" :can-edit="false" v-for="tender in tenders" :key="tender.id"/>
          </div>
        </div>
      </div>
    </div>
    <add-cpv-modal :closable="false"/>
  </div>
</template>
<script>

import TenderCard from '@/components/timelessTenders/tenderCard.vue'

export default {
  components: { TenderCard },
  data() {
    return {
      dateNow: new Date(),
      backendUrl: process.env.VUE_APP_URL,
      tenders: [],
      selectedType: 'all',
      searchQuery: '',
      cpvs: [],
      columns: [
        'password',
        'title',
        'products',
        'opening_finish_date',
        'price',
        'region',
        'type',
        'invitation',
        'edit',
        'participants_count'
      ],
    }
  },
  computed: {
    currentPlan() {
      return this.$store.getters['procurement/currentPlan']
    },
    locale() {
      return this.$store.getters['user/locale']
    }
  },
  mounted() {
    this.getTenders();
  },
  methods: {
    getTenders() {
      this.$client.get('timeless-tenders', {
        params: {
          favorite: true,
          type: 'all',
        }
      }).then(({ data }) => {
        console.log('data', data.data)
        this.tenders = data.data;
      })
    },
  },
}
</script>
<style scoped>
.cpv-select-block{
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  .cpv-select-btn{
    height: 36px;
    width: 365px;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #2D3036;
    }
  }
}
@media (max-width: 1024px) {
  .cpv-select-block, .cpv-search-block{
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .cpv-select-btn{
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .filter-block{
    flex-direction: column !important;
  }
  .cpv-select-block, .cpv-search-block{
    width: 100% !important;
    padding: 0 !important;
  }
 .cpv-search-block{
   padding: 20px 0 0 0 !important;
 }
}
</style>

